import { Icon } from "@iconify/react/dist/iconify.js";
import { useState, useEffect, useRef } from "react";

const SearchInput = ({
  value = "",
  onChange,
  placeholder = "Buscar...",
  minChars = 3,
  debounceMs = 500,
  className = "",
}) => {
  const [localSearch, setLocalSearch] = useState(value);
  const debounceTimeout = useRef(null);

  useEffect(() => {
    setLocalSearch(value);
  }, [value]);

  const handleSearchChange = (e) => {
    const newValue = e.target.value;
    setLocalSearch(newValue);

    // Clear timeout anterior
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    // Solo buscar si tiene minChars o más caracteres, o si está vacío (para limpiar)
    debounceTimeout.current = setTimeout(() => {
      if (newValue.length >= minChars || newValue.length === 0) {
        onChange(newValue);
      }
    }, debounceMs);
  };

  const handleClearSearch = () => {
    setLocalSearch("");
    onChange("");
  };

  const showWarning = localSearch.length > 0 && localSearch.length < minChars;

  return (
    <div
      className={`position-relative ${className}`}
      style={{ maxWidth: "400px" }}
    >
      <Icon
        icon="mdi:magnify"
        width="20"
        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary-light"
        style={{ pointerEvents: "none" }}
      />

      <input
        type="text"
        value={localSearch}
        onChange={handleSearchChange}
        placeholder={placeholder}
        className={`form-control ps-5 pe-5 radius-8 border-neutral-200 ${
          showWarning ? "border-warning" : ""
        }`}
        style={{
          height: "44px",
          fontSize: "14px",
          transition: "all 0.3s ease",
        }}
      />

      {localSearch && (
        <button
          onClick={handleClearSearch}
          className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2 p-0 border-0 bg-transparent"
          style={{ width: "24px", height: "24px" }}
          title="Limpiar búsqueda"
        >
          <Icon
            icon="mdi:close-circle"
            width="20"
            className="text-secondary-light"
          />
        </button>
      )}

      {showWarning && (
        <small className="text-warning d-block mt-1 ms-1">
          <Icon icon="mdi:information-outline" width="14" className="me-1" />
          Mínimo {minChars} caracteres para buscar
        </small>
      )}
    </div>
  );
};

export default SearchInput;
